import { Injectable } from '@angular/core';
import { Label, LanguageService } from '@services/public';
import { ChartConfiguration } from 'chart.js';
import { dateString, JDate } from 'jakapa-utilities-lite';

export interface LeaderReportAPIResponseGrowth {
	date: dateString;
	self: number;
	peer: number;
}

@Injectable({
	providedIn: 'root',
})
export class LeaderReportGrowthService {
	// Page langauge.
	labels: { [key in Label]?: string } = {
		[Label.PEER]: '',
		[Label.SELF]: '',
	};

	constructor(private _languageSvc: LanguageService) {
		// Get page language.
		this._languageSvc.getLabels(this.labels);
	}

	generateReport(
		data: Array<LeaderReportAPIResponseGrowth>,
	): ChartConfiguration {
		const labels: Array<string> = [];
		const selfData: Array<number> = [];
		const peerData: Array<number> = [];

		for (const dateData of data) {
			labels.push(new JDate(dateData.date).toEnString());
			selfData.push(dateData.self);
			peerData.push(dateData.peer);
		}

		return {
			type: 'line',
			data: {
				labels,
				datasets: [
					{
						label: this.labels[Label.SELF],
						data: selfData,
						backgroundColor: '#3BE684',
						borderColor: '#3BE684',
					},
					{
						label: this.labels[Label.PEER],
						data: peerData,
						backgroundColor: '#74A2FF',
						borderColor: '#74A2FF',
					},
				],
			},
			options: {
				maintainAspectRatio: false,
				plugins: {
					legend: {
						display: true,
						position: 'top',
						align: 'end',
						labels: {
							useBorderRadius: true,
							borderRadius: 5.5,
							boxWidth: 10,
							boxHeight: 10,
						},
					},
				},
				elements: {
					line: {
						fill: false,
						spanGaps: true,
					},
					point: {
						pointStyle: 'circle',
						radius: 5,
					},
				},
			},
		};
	}
}
